import {Container, interfaces} from 'inversify';
import {AlbumProvider} from '../services/injectable/AlbumProvider/AlbumProvider';
import {IAlbumProvider} from '../services/injectable/AlbumProvider/IAlbumProvider';
import {ExperimentsApi} from '../services/injectable/ExperimentsApi/ExperimentsApi';
import {IExperimentsApi} from '../services/injectable/ExperimentsApi/IExperimentsApi';
import {IImageUtils} from '../services/injectable/ImageUtils/IImageUtils';
import {ImageUtils} from '../services/injectable/ImageUtils/ImageUtils';
import {IMediaPlatformApi} from '../services/injectable/MediaPlatformApi/IMediaPlatformApi';
import {MediaPlatformApi} from '../services/injectable/MediaPlatformApi/MediaPlatformApi';
import {ISiteInfoProvider} from '../services/injectable/SiteInfoProvider/ISiteInfoProvider';
import {SiteInfoProvider} from '../services/injectable/SiteInfoProvider/SiteInfoProvider';
import {ISiteSettingsProvider} from '../services/injectable/SiteSettingsProvider/ISiteSettingsProvider';
import {SiteSettingsProvider} from '../services/injectable/SiteSettingsProvider/SiteSettingsProvider';
import {ILocationService} from '../services/LocationService/ILocationService';
import {LocationService} from '../services/LocationService/LocationService';
import {Player} from '../services/player/player';
import {IWixPubSub} from '../services/WixPubSub/IWixPubSub';
import {WixPubSub} from '../services/WixPubSub/WixPubSub';
import {services} from './services';

export function inversifyConfig(container: Container) {
  container.bind<ILocationService>(services.location).to(LocationService);
  container.bind<IWixPubSub>(services.wixPubSub).to(WixPubSub);
  container.bind<ISiteInfoProvider>(services.siteInfo).to(SiteInfoProvider);
  container.bind<IAlbumProvider>(services.albumProvider).to(AlbumProvider);
  container.bind<ISiteSettingsProvider>(services.siteSettings).to(SiteSettingsProvider);
  container.bind<IExperimentsApi>(services.experiments).to(ExperimentsApi);
  container.bind<IImageUtils>(services.imageUtils).to(ImageUtils);
  container.bind<interfaces.Newable<Player>>(services.Player).toConstructor(Player);
  container.bind<IMediaPlatformApi>(services.mediaPlatformApi).to(MediaPlatformApi);
}
